import React, {useEffect, useState} from 'react';
import Modal from 'react-bootstrap/Modal';
import logo from "../../../assets/images/logo-sm.svg"
import {getCookie} from "../../../assets/cookies";
import {
    firstHomeScheme, firstHomeSchemeCouncil, firstHomeSchemeType,
    helpToBuyScheme, loanRequired,loanTerm,
    mortgageType,
    twoApplicants
} from "../../../common/section-questions/mortgage/setup";
import Answer from "../../inputs/Answer";
import {isSectionQuestionHidden} from "../../../common/section-questions/sections";


function FirstVisitModal(props) {
    const [state,setState] = useState({open:true,position:'bottom'})
    const _props = {mortgage: props.mortgage}
    const section = {
        props: _props,
        applicant: false,
        questions: [
            mortgageType(_props),
            twoApplicants(_props),
            helpToBuyScheme(_props),
            firstHomeScheme(_props),
            firstHomeSchemeCouncil(_props),
            firstHomeSchemeType(_props),
            loanRequired(_props),
            loanTerm(_props)
        ]
    }
    const handleOnHide = ()=>{
        setState(prev=> {
            return {...prev,open: false}
        })
    }
    useEffect(()=>{
        setState(prev=>{
            return {...prev,position: ''}
        })
        console.log(getCookie())
    },[])
    const visibleQuestions =  section.questions.filter(question => {
        return !isSectionQuestionHidden(section, question)
    })

    return (
        <Modal show={state.open} onHide={handleOnHide} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title className="d-flex justify-content-center flex-fill">

                        <div className="d-flex flex-column align-items-center w-100">

                                <small className="pt-3 text-primary bold font-alt">Let's get your mortgage</small>
                                <img className="pb-3" src={logo} alt={"SUSSD LOGO"} style={{width:'120px'}}/>
                        </div>


                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <h4 className="text-center">Hi {props.mortgage.applicant1.firstName}!</h4>
                <p className="text-center">Tell us a little about your needs</p>
                <div className={`pt-2 question-transition ${state.position}`}>
                    {visibleQuestions.map((question, index) => {
                        return (
                            <div key={question.text+question.label} className={`transitionable delay-${index+1}`}>
                                <Answer editing={true} floating={true} key={'section-question-' + question.label} question={question} section={section}/>
                            </div>
                        )
                    })
                    }
                </div>
            </Modal.Body>

            <Modal.Footer>
                <button className="btn btn-secondary font-alt">I want to work out costings</button>
                <button className="btn btn-primary font-alt">I want to apply for a mortgage</button>
            </Modal.Footer>

        </Modal>
    );
}

export default FirstVisitModal;